import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { TSuggest } from 'feature/registration/types'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'

export interface SavedAddressList {
  list: SavedAddress[]
}

export interface SavedAddress extends TSuggest {
  id: number
  isMain: boolean
}

// API для страницы "/myaddresses"
export const myAddressesApi = createApi({
  reducerPath: 'MyAddresses',
  refetchOnMountOrArgChange: true,
  baseQuery: getBaseQueryAuth,
  tagTypes: ['MyAddressesList'],
  endpoints: builder => ({
    // получения списка моих адресов
    getAddressList: builder.query<SavedAddressList, void>({
      query: () => ({
        url: '/v1/customer/address',
        method: 'GET',
      }),
      providesTags: ['MyAddressesList'],
      transformResponse: (response: SavedAddressList) => {
        const sortedList = response.list.slice().sort((a, b) => {
          return a.isMain === b.isMain ? 0 : a.isMain ? -1 : 1
        })
        return {
          ...response,
          list: sortedList,
        }
      },
    }),
    // добавления нового адреса
    addAddress: builder.mutation<SavedAddressList, TSuggest>({
      query: body => ({
        url: '/v1/customer/address',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['MyAddressesList'],
    }),
    // изменения адреса
    changeAddress: builder.mutation<
      SavedAddressList,
      { id: number; body: TSuggest }
    >({
      query: ({ id, body }) => ({
        url: `/v1/customer/address/${id}`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['MyAddressesList'],
    }),
    // удаления адреса
    removeAddress: builder.mutation<
      {
        message: string
      },
      number
    >({
      query: id => ({
        url: `/v1/customer/address/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MyAddressesList'],
    }),
  }),
})

export const {
  useGetAddressListQuery,
  useAddAddressMutation,
  useChangeAddressMutation,
  useRemoveAddressMutation,
} = myAddressesApi
